import NOTIFICATION_API from 'constants/notification/api';
import NOTIFICATION_FORM from 'constants/notification/form';
import NOTIFICATION_ACCOUNT from 'constants/notification/services/account';
import NOTIFICATION_BILLING from 'constants/notification/services/billing';
import NOTIFICATION_GAME_HOSTING from 'constants/notification/services/gameHosting';

const NOTIFICATIONS = { ...NOTIFICATION_API, ...NOTIFICATION_ACCOUNT, ...NOTIFICATION_BILLING, ...NOTIFICATION_GAME_HOSTING, ...NOTIFICATION_FORM };

export default NOTIFICATIONS;
